import {
  faExternalLink,
  faLink,
  faLinkSlash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router';
import type { UpdatePaleomapPageQuery } from '~/apollo/generated/v4/graphql';
import { Confirm } from '~/components/common/Confirm';
import { NoItemsAlert } from '~/components/common/NoItemsAlert';
import { Panel } from '~/components/common/Panel';
import { Tooltip } from '~/components/common/Tooltip';
import { Button } from '~/components/ui/button';
import { uploadOutcropUpdateRoute } from '~/paths';
import type { RefetchQueries } from '~/utils/graphql';
import { CreatePaleoMapOutcropLink } from './create-outcrop-link';
import { RemovePaleoMapOutcropLink } from './remove-outcrop-link';

export function PaleoMapOutcropManager({
  paleoMap,
  refetchQueries,
}: {
  paleoMap: NonNullable<UpdatePaleomapPageQuery['paleoMapGet']>;
  refetchQueries: RefetchQueries;
}) {
  return (
    <Panel>
      <Panel.Heading className="flex justify-between">
        <Panel.Title>Linked Outcrops</Panel.Title>

        <CreatePaleoMapOutcropLink
          paleoMapId={parseInt(paleoMap.id)}
          currentOutcropIds={paleoMap.outcrops.map(oc => parseInt(oc.id))}
          refetchQueries={refetchQueries}
        >
          {showModal => (
            <Button
              type="button"
              color="primary"
              size="xs"
              onClick={showModal}
              startIcon={<FontAwesomeIcon icon={faLink} />}
            >
              Link Outcrop
            </Button>
          )}
        </CreatePaleoMapOutcropLink>
      </Panel.Heading>

      <Panel.Body>
        <NoItemsAlert show={!paleoMap.outcrops.length} entity="outcrops" />

        <div className="space-y-1">
          {paleoMap.outcrops.map(oc => (
            <div
              key={oc.id}
              className="border border-slate-200 p-2 flex justify-between items-center gap-2"
            >
              <div>
                <div>
                  <Link
                    to={uploadOutcropUpdateRoute(parseInt(oc.id))}
                    target="_blank"
                    className="link space-x-2"
                  >
                    <strong>{oc.name}</strong>
                    <FontAwesomeIcon
                      icon={faExternalLink}
                      className="text-muted text-sm"
                    />
                  </Link>
                </div>
                <div>{oc.region.name}</div>
              </div>

              <RemovePaleoMapOutcropLink
                paleoMapId={parseInt(paleoMap.id)}
                outcropId={parseInt(oc.id)}
                refetchQueries={refetchQueries}
              >
                {(handleDelete, loading) => (
                  <Confirm
                    onConfirm={handleDelete}
                    text={`The link with ${oc.name} will be deleted.`}
                    submitButtonColor="error"
                    submitText="Delete Link"
                  >
                    {handleConfirm => (
                      <Button
                        type="button"
                        color="ghost"
                        size="xs"
                        onClick={handleConfirm}
                        loading={loading}
                      >
                        <Tooltip message="Unlink outcrop">
                          <FontAwesomeIcon icon={faLinkSlash} />
                        </Tooltip>
                      </Button>
                    )}
                  </Confirm>
                )}
              </RemovePaleoMapOutcropLink>
            </div>
          ))}
        </div>
      </Panel.Body>
    </Panel>
  );
}
